import type { AutomationItem } from "../types";

export interface AutomationPanelItem {
  id: AutomationItem["id"];
  title: string;
  description: string;
  triggerMoment?: string;
  statusLabel: string;
  color: "success" | "primary";
  statusChipVariant: "filled" | "outlined";
  isConfigured: boolean;
  messageTemplateLabel?: string;
  questionnaireLabel?: string;
  questionnaireId?: string;
  linkedMessageTemplate?: AutomationItem["linkedMessageTemplate"];
}

export function toAutomationPanelItem(automation: AutomationItem): AutomationPanelItem {
  const isConfigured = automation.isConfigured;

  return {
    id: automation.id,
    title: automation.title,
    description: automation.description,
    triggerMoment: automation.triggerMoment,
    statusLabel: isConfigured ? "Configurada" : "Não configurada",
    color: isConfigured ? "success" : "primary",
    statusChipVariant: isConfigured ? "filled" : "outlined",
    isConfigured,
    messageTemplateLabel: automation.messageTemplateName,
    questionnaireLabel: automation.questionnaireName,
    questionnaireId: automation.questionnaireId,
    linkedMessageTemplate: automation.linkedMessageTemplate,
  };
}
